import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.bodyType;

const getBodyType = createSelector(getData, bodyType => values(bodyType));

export default getBodyType;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getBodyType.js